import { useMemo } from 'react';

import { useI18n } from '#/i18n/hooks/useI18n';
import type { ApiUserProfileWorkHistoryJob } from '#/modules/userProfile/api/types/ApiUserProfileWorkHistoryJob';
import { POSITION_TYPES } from '#/utils/constants/employmentProfile';
import { humanMonthYear } from '#/utils/string/datetime/dateString';

export function useFormatUserProfileWorkHistoryJobItem(
  job: ApiUserProfileWorkHistoryJob,
) {
  const { locale } = useI18n();

  return useMemo(() => {
    const formattedWorkHistoryItem: {
      positionType?: string;
      dateRange?: string | null;
      employmentType?: string;
    } = {
      dateRange: null,
    };

    if (job.positionType !== 'JOB') {
      const option = POSITION_TYPES.find((t) => t.value === job.positionType);
      if (option) {
        formattedWorkHistoryItem.positionType = option.label;
      }
    }

    if (job.startDate) {
      const startDate = humanMonthYear(job.startDate, {
        locale,
        monthFormat: 'short',
      });
      let endDate = null;

      if (job.endDate) {
        endDate = humanMonthYear(job.endDate, {
          locale,
          monthFormat: 'short',
        });
      } else if (job.isCurrent) {
        endDate = 'Present';
      }

      formattedWorkHistoryItem.dateRange = [startDate, endDate]
        .filter(Boolean)
        .join(' – ');
    }

    if (!job.isFullTime) {
      formattedWorkHistoryItem.employmentType = 'Part time';
    } else {
      formattedWorkHistoryItem.employmentType = 'Full time';
    }

    return formattedWorkHistoryItem;
  }, [locale, job]);
}
